// extracted by mini-css-extract-plugin
export var highlightOriginal = "_68-0";
export var highlightSuggested = "_68-1";